// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-298fdffe] {\n  padding: 32px 0;\n}\ni[data-v-298fdffe] {\n  font-size: 32px;\n  color: #868383;\n}\nspan[data-v-298fdffe] {\n  color: #868383;\n}\n", ""]);
// Exports
module.exports = exports;
